var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "row roomy align-center align-stretch" },
    _vm._l(_vm.filteredSkus, function (sku, index) {
      return _c(
        "div",
        {
          key: sku,
          class: [
            "column-12 size-sm",
            _vm.filteredSkus.length === 2
              ? "laptop:column-6"
              : "laptop:column-4",
          ],
        },
        [
          !_vm.isLoading
            ? _c("plan-summary-card", {
                attrs: {
                  "is-last": _vm.filteredSkus.length === index + 1,
                  "is-single-plan-modal": _vm.filteredSkus.length === 1,
                  "modal-context-slug": _vm.upsellTriggerSlug,
                  sku: _vm.getPlan(sku).sku,
                  "is-in-modal-context": "",
                  "subscription-discounts": _vm.subscriptionDiscounts,
                },
              })
            : _vm._e(),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }